import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

/** 取引先区分 */
enum BusinessConnectionType {
  supplier = 'SUPPLIER',
  lentParty = 'LENT_PARTY',
  payee = 'PAYEE',
  buyer = 'BUYER',
}

const nameConfig = {
  supplier: new Map([[Locale.ja, '購入先']]),
  lentParty: new Map([[Locale.ja, '貸出先']]),
  payee: new Map([[Locale.ja, '支払先']]),
  buyer: new Map([[Locale.ja, '売却先']]),
};

const toEnum = rawValueToEnum(BusinessConnectionType, BusinessConnectionType.supplier);
const toDisplay = enumToName(BusinessConnectionType, nameConfig);
const toDisplayWithPrefix = enumToName(BusinessConnectionType, nameConfig, { prefix: true });

export const businessConnectionType = {
  enum: BusinessConnectionType,
  nameConfig,
  toEnum,
  toDisplay,
  toDisplayWithPrefix,
};
export type { BusinessConnectionType };
